export const SET_ITEMS = 'SET_ITEMS';
export const SET_TOTAL = 'SET_TOTAL';
export const SET_CRITERES = 'SET_CRITERES';
export const SET_LAST_PAYLOAD = 'SET_LAST_PAYLOAD';
export const SET_ITEMS_VIEW = 'SET_ITEMS_VIEW';
export const SET_TOTAL_VIEW = 'SET_TOTAL_VIEW';
export const SET_CAMPAGNE = 'SET_CAMPAGNE';
export const SET_DEMANDE_IMPRESSION = 'SET_DEMANDE_IMPRESSION';
